export var ApprovalCheckErrorSubcodes;
(function (ApprovalCheckErrorSubcodes) {
    ApprovalCheckErrorSubcodes["InsufficientCredits"] = "ERROR_INSUFFICIENT_CREDITS";
})(ApprovalCheckErrorSubcodes || (ApprovalCheckErrorSubcodes = {}));
